module.exports = "../fonts/SFUIText-Light.eot";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/SFUIText-Light.eot
// module id = 576
// module chunks = 0